import { getWishlistTagsAction } from "@/actions/wishlist";
import { useMarket } from "@app/_context";
import useAuth from "@features/auth/hooks/useAuth";
import { useQuery } from "@tanstack/react-query";

export default function useWishlistTags() {
  const { market } = useMarket().state;
  const { token } = useAuth();

  return useQuery({
    queryKey: ["wishlist", "tags", token],
    queryFn: () =>
      getWishlistTagsAction({
        token: token!,
        locale: market.serviceLocale,
      }),
    select: (data) => data.tags,
    enabled: Boolean(token),
  });
}
